import apiHandler from "../core/apiHandler";

const testProgressAdminApi = apiHandler("dte/test-progress/manage");

export default testProgressAdminApi;
